module.exports = __webpack_public_path__ + "img/caopijiang.7e76e02d.jpg";